import axios from 'axios'
import { baseURL } from './config.js'
import qs from 'qs'

// 公共接口
export default {
  // 上传文件
  upload(params) { 
    const url =  baseURL + '/tbPic/modify';
    return url;
  },
  getLBlist(params) { //轮播图列表
    const url =  baseURL + '/tbLunbotu/list';
    //const url =  baseURL + '/tbPic/list';
    return axios.post(url, qs.stringify(params));
  },
  delLBlist(params) { //删除轮播图
    const url =  baseURL + '/tbLunbotu/delete';
    // const url =  baseURL + '/tbPic/delete';
    return axios.post(url, qs.stringify(params));
  },
  setLBlist(params){//保存轮播图
    const url =  baseURL + '/tbLunbotu/modify';
    return axios.post(url, qs.stringify(params));
  },

  setLoglist() { //设置产品logo
    const url =  baseURL + '/tbPic/setProductLogo';
    return url;
  },
  setCompanyPic() { //设置企业logo
    const url =  baseURL + '/tbPic/modify';
    return url;
  },
  
  getLBTDetail(params) { //轮播图详情
    const url =  baseURL + '/tbLunbotu/getDetail';
    //const url =  baseURL + '/tbPic/list';
    return axios.post(url, qs.stringify(params));
  },
  
}


// WEBPACK FOOTER //
// ./src/api/common.js